import axios from "axios";
import API from "../helpers/endpointService" 

export const getShipTypeList = (Id) => {
    let url = `${API.Get_ShipStatusList}?typeId=${Id}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getShipTypeListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getShipTypeListFailure",
            error: "ERROR",
          });
        });
    };
  };
  export const getStatusTypeList = (Id) => {
    let url = `${API.Get_ShipStatusList}?typeId=${Id}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getStatusListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getStatusListFailure",
            error: "ERROR",
          });
        });
    };
  };
  export const getSubCategoryList = (Id) => {
    let url = `${API.Get_ShipStatusList}?typeId=${Id}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getSubCategoryListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getSubCategoryListFailure",
            error: "ERROR",
          });
        });
    };
  };
  export const getInspectionTypeList = (Id) => {
    let url = `${API.Get_ShipStatusList}?typeId=${Id}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getInspectionTypeListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getInspectionTypeListFailure",
            error: "ERROR",
          });
        });
    };
  };